<ngx-spinner bdColor = "rgba(51, 51, 51, 0.8)" size = "large" color = "#fff" type = "ball-clip-rotate-multiple"></ngx-spinner>
<router-outlet></router-outlet>
